import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ProtectRoute = ({children}) => {
    const navigate = useNavigate();
    const { userResult } = useSelector((state) => state.Auth);
    const token = userResult?.token;
    const userType = userResult?.usertype;
    useEffect(() => {
        if(!token || userType !== "ADMIN"){
            navigate('/admin-login');
            return;
        }
    })
    

    return children;
}

export default ProtectRoute;
